import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import GetName from 'utils/getName';
import getSi from 'utils/getSi';
import updateHealthIssuesAnswers from 'utils/updateHealthIssuesAnswers';
import updateQuizInfo, { getQuizInfo } from 'utils/updateQuizInfo';
import DotDetails from '../DotDetails/DotDetails';
import DotSelector from '../DotSelector/DotSelector';

import QuizSlideHeading from '../QuizSlideHeading/QuizSlideHeading';
import QuizSlideNavigation from '../QuizSlideNavigation/QuizSlideNavigation';

const QuizDigestiveCareTwo = () => {
  const navigate = useNavigate();
  const si = getSi();

  const [name, setName] = useState('');
  const contextName = useSelector((state) => state.quiz.name);
  const dispatch = useDispatch();

  useEffect(() => {
    const dogName = async () => {
      if (contextName) {
        setName(contextName);
      } else {
        const n = await GetName(si, dispatch);
        setName(n);
      }
    };
    dogName();
  }, [si]);

  useEffect(() => {
    const info = getQuizInfo();
    if (info?.digestion_q2) {
      setOption(info.digestion_q2);
    }
  }, []);

  useEffect(() => {
    if (si) {
      updateQuizInfo({ slide: 'digestive-care-2' });
      sessionStorage.setItem(
        'current_health_issue',
        JSON.stringify('digestive-care'),
      );
    } 
  }, [si]);

  const [option, setOption] = useState(1);
  const dotSelectorData = [{ name: 1 }, { name: 2 }, { name: 3 }];
  const handleClick = () => {
    if (option) {
      updateQuizInfo({ digestion_q2: option });
      updateHealthIssuesAnswers({ digestion_q2: option });
      navigate(`/quiz/digestive-care-3/?si=${si}`);
    }
  };

  const dotDetailsData = [
    {
      title: 'Not at all',
      body: 'My dog’s bowel movements are as regular as clockwork',
    },
    {
      title: 'Somewhat',
      body: 'My dog’s toileting schedule is a little unpredictable',
    },
    {
      title: 'Significantly',
      body: 'My dog is very irregular with their bowel movements - it’s hard to know what’s going to happen when!',
    },
  ];
  return (
    <section className="min-h-screen bg-dteal-50 pt-24 md:pt-4">
      <div className="px-9 container mx-auto flex h-screen flex-col items-center justify-center gap-9">
        <QuizSlideHeading
          before={`Does ${name}`}
          title="Go to the toilet at an unpredictable/irregular
          frequency?"
        />
        <div>
          <DotSelector
            data={dotSelectorData}
            option={option}
            setOption={setOption}
            details={dotDetailsData}
          />
          <DotDetails details={dotDetailsData} />
        </div>
        <QuizSlideNavigation  handleBack={()=>navigate(-1)}   handleNext={handleClick} />
      </div>
    </section>
  );
};

export default QuizDigestiveCareTwo;
